import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {CircularProgress} from '@mui/material';
import {isAuthRedirectError} from '../../../shared/services/auth.service';
import {logError} from '../../../shared/services/logger.service';
import {RecordMessage} from '../../../shared/components/record/RecordKit';
import {InvoiceDto} from '../../invoice/dtos/invoice.dto';
import {getInvoice} from '../../invoice/invoice.service';
import EstimateRecordPage from './EstimateRecordPage';

/*
 * An invoice's own page (/invoices/7, SQ-598): as on Android, an invoice opens
 * on its job's record, so this reads the invoice and opens the record as that
 * job with the invoice on it.
 */
const InvoiceRecordPage = ({invoiceId, onChanged}: {invoiceId: number; onChanged?: () => void}) => {
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState<InvoiceDto>();
  const [error, setError] = useState<string>();
  useEffect(() => {
    let active = true;
    getInvoice(navigate, invoiceId)
      .then(found => active && setInvoice(found))
      .catch(e => {
        if (!active || isAuthRedirectError(e)) return;
        logError('Error getting the invoice', {invoiceId}, e as Error);
        setError(`Couldn't load this invoice: ${e}`);
      });
    return () => { active = false; };
  }, [navigate, invoiceId]);
  if (error) return <RecordMessage error text={error}/>;
  if (!invoice) return <CircularProgress/>;
  if (!invoice.estimate) return <RecordMessage error text="This invoice has no job to show."/>;
  return <EstimateRecordPage estimateId={invoice.estimate.id} workOrderId={invoice.workOrderId} invoice={invoice} onChanged={onChanged}/>;
};

export default InvoiceRecordPage;
